import { Badge, Button, Card, Group, Stack, Text } from '@mantine/core'
import type { SubscriptionWithRelations } from '@markku/types'

interface SubscriptionOverviewCardProps {
  subscriptionDetails: SubscriptionWithRelations | undefined
  onManageClick: () => void
}

export function SubscriptionOverviewCard({
  subscriptionDetails,
  onManageClick,
}: SubscriptionOverviewCardProps) {
  const basePrice = subscriptionDetails?.basePriceMonthly
  const effectivePrice = subscriptionDetails?.effectivePriceMonthly
  const hasDiscount = effectivePrice && effectivePrice !== basePrice

  return (
    <Card withBorder p="sm" bg="green.0">
      <Group justify="space-between" align="center">
        <Stack gap={4}>
          <Group gap="xs">
            <Text fw={600} size="sm">
              Markku-paketti
            </Text>
            <Badge color="green" variant="filled" size="xs">
              Aktiivinen
            </Badge>
          </Group>
          <Group gap="xs">
            <Text fw={600}>{subscriptionDetails?.displayName}</Text>
            <Group gap={4}>
              {hasDiscount && (
                <Text fw={700} td="line-through" c="dimmed">
                  {basePrice}€
                </Text>
              )}
              <Text fw={700}>
                {hasDiscount ? effectivePrice : basePrice}€/kk
              </Text>
            </Group>
          </Group>
        </Stack>
        <Button variant="light" color="green" size="xs" onClick={onManageClick}>
          Hallinnoi
        </Button>
      </Group>
    </Card>
  )
}
